import { gql } from "@apollo/client";

export const CREATE_USER_CONFIRM = gql`
  mutation CreateUserConfirm($data: UserConfirmInput!) {
  createUserConfirm(data: $data) {
    id
  }
}
`;

// ຫາ (ຫຼືສ້າງ) ບັນຊີຈາກເບີໂທ ໂດຍບໍ່ຕ້ອງມີ PIN — ເອີ້ນຕອນບັນທຶກທີ່ຢູ່ໃໝ່ເທົ່ານັ້ນ
export const ENSURE_USER_CONFIRM_BY_PHONE = gql`
  mutation EnsureUserConfirmByPhone($phone: String!) {
    ensureUserConfirmByPhone(phone: $phone) {
      id
      name
      phone
    }
  }
`;

export const CONFIRM_USER_ACCOUNT = gql`
  mutation ConfirmUserAccount($data: userConfirmInputV2!) {
    confirmUserAccount(data: $data) {
      message
      token
      userConfirm {
        id
        role
        email
        name
        phone
        psid
        addressCF
        isBlocked
        isDeleted
        account
        note
        image
        userAuthId
        createdAt
        updatedAt
      }
    }
  }
`;
export const CONFIRM_USER_AUTH = gql`
  mutation ConfirmUserAuth($token: String!) {
    confirmUserAuth(token: $token) {
      message
      token
      userConfirm {
        id
        role
        email
        name
        phone
        psid
        addressCF
        shop {
          id
        }
        isBlocked
        isDeleted
        account
        note
        image
        userAuthId
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_USER_CONFIRM = gql`
  mutation UpdateUserConfirm($data: UserConfirmInput!, $where: UserConfirmWhereInputOne!) {
    updateUserConfirm(data: $data, where: $where) {
      message
    }
}
`;

export const CUSTOMER_UPDATE_ORDER = gql`
  mutation CustomerUpdateOrderGroup($where: OrderGroupWhereInputOne!, $data: OrderGroupInput!) {
    customerUpdateOrderGroup(where: $where, data: $data) {
      dataOne {
        id
        amount
        phone
        address
        totalPrice
        sumPriceBaht
        sumPriceUsd
        sumPrice
        cfName
        customerName
        customerImage
        userFbId
        unsendMessage
        sendMessage
        tag
        tagColor
        code
        shipmentNumber
        shipPrice
        paymentType
        status
        invoiceStatus
        infulancerInvoiceStatus
        shopStatus
        payment
        isPaymented
        paySlip
        paySlips
        logistic
        originalLogistic
        destinationLogistic
        addressCf
        type
        isReply
        isDeleted
        createdAt
        updatedAt
        note
        transactionId
        infulancer_percent
        commissionAffiliate
        typeForAffiliate
        totalServiceCharge
        commissionService
        commissionInfluencer
        totalAffiliate
        isPaymentSupport
        isClaimBalance
        confirmBalance
        servicePaymentSupport
        jointOrder
        dataConfirmCod
        paymentMethod
        rate
      }
      msg
      status
    }
  }
`;
